import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconLens: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconLens"><Path d="M7.99853 14.3092V9.6906M7.99853 14.3092L11.9987 16.6187M7.99853 14.3092L3.07031 11.4639M7.99853 9.6906L11.9987 7.38109M7.99853 9.6906V4M11.9987 7.38109L15.9985 9.69037M11.9987 7.38109L16.9267 4.5359M15.9985 9.69037V14.3094M15.9985 9.69037L20.9267 12.5357M15.9985 14.3094L11.9987 16.6187M15.9985 14.3094V20M11.9987 16.6187L7.07033 19.4641" stroke="currentColor" strokeWidth="1.5"/><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconLens;
